"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base32 = exports.formatNumber = exports.chunk = exports.pad = void 0;
const baseN_1 = require("../models/baseN");
const pad = (str, size) => (new Array(size + 1).join('0') + str).slice(-size);
exports.pad = pad;
const chunk = (str, size) => {
    const chunks = new Array(str.length / size + .5 | 0);
    const nChunks = chunks.length;
    let newo = 0;
    for (let i = 0, o = 0; i < nChunks; ++i, o = newo) {
        newo += size;
        chunks[i] = str.substr(o, size);
    }
    return chunks;
};
exports.chunk = chunk;
const formatNumber = (value, decimals = 2) => value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
exports.formatNumber = formatNumber;
exports.base32 = new baseN_1.BaseN('0123456789ABCDEFGHKMNPQRSTUVWXYZ');
//# sourceMappingURL=format.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libs-tools/functions/format.js
// module id = 488
// module chunks = 0